<template>
  <div v-if="STATE > states.NULL" class="sessionTimer noselect" :style="customTimerStyles">
    <!-- Countdown to session -->
    <div v-if="STATE === states.LESS_THAN_ONE || STATE === states.LESS_THAN_TEN">
      {{ `Session starts in ${getTimeToSessionStart} minutes.` }}
    </div>
    <!-- Session ongoing -->
    <div v-else-if="STATE === states.STARTED || STATE === states.GRACE_OVER" class="message">
      {{ `Ends in ${getTimeToSessionEnd}` }}
      <!-- <Modal
        v-if="!sessionCompleteConfirmed && !sessionCompleteCheckDone"
        @callModalSecondAction="confirmCompleteSession"
        type="SessionComplete"
      /> -->
    </div>
    <!-- Timer finished -->
    <div v-else-if="STATE === states.SESSION_END" class="message">
      Session completed!
    </div>
  </div>
  <div v-else-if="isCompleted" class="sessionTimer noselect" :style="transparentColor">
    <div class="message">Session completed!</div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import api from "../../api/cofocusAPI";
import Timer from "./Timer";

import { playEndAudio } from "../../pages/RoomPages/Session/SessionHelpers/sound";

import { transparentColor } from "../../pages/RoomPages/Session/SessionHelpers/colors";

import { SESSION_LENGTH_MS } from "../../constants_calendar";

export default {
  name: "InSessionTimer",
  mixins: [Timer],
  props: ["sessionLoaded", "isCompleted", "timerVisible"],
  data() {
    return initialDataState();
  },
  computed: {
    ...mapState({
      sessionCompleteConfirmed: (state) => state.session.sessionCompleteConfirmed,
      hasCompletedSession: (state) => state.onboarding.hasCompletedSession, // Whether user has completed any sessions, for onboarding
    }),
    getTimeToSessionStart() {
      return new Date(this.nextSessionDateTimeMS - this.time_seconds).toISOString().substr(14, 5);
    },
    getTimeToSessionEnd() {
      return new Date(this.nextSessionDateTimeMS + SESSION_LENGTH_MS - this.time_seconds).toISOString().substr(14, 5);
    },
    transparentColor() {
      return transparentColor();
    },
    customTimerStyles() {
      let styles = transparentColor();
      if (!this.timerVisible) {
        styles = styles + " " + "opacity: 0;";
      }
      return styles;
    }
  },
  methods: {
    async completeSession() {
      this.$store.dispatch("session/setSessionComplete", true);
      this.$store.dispatch("session/setCompletionModalOpenState", true);
      console.log("session should be completing");
      window.document.title = "Session completed!";
      if (!this.sessionCompleteConfirmed) {
        console.log("startin end audio...");
        playEndAudio();
      }

      this.sessionConclusionDone = true;
      if (!this.hasCompletedSession) {
        this.$store.dispatch("onboarding/setHasCompletedSession", true);
      }

      /* if (!this.sessionConclusionDone) {
        try {
          const response = await api.REQUEST({
            method: "post",
            url: "api/sessions/upcoming/conclude",
            data: {
              UID: this.userID,
            },
            withCredentials: true,
          });
          console.log("response: ", response);
          this.sessionConclusionDone = true;
          if (!this.hasCompletedSession) {
            this.$store.dispatch("onboarding/setHasCompletedSession", true);
          }
        } catch (error) {
          console.error("@completeSession error: ", error);
        }
      } */
    },

    async setUserAsJoined() {
      console.log("setting user as joined, the nextSessionData: ", JSON.parse(JSON.stringify(this.nextSession)));
      if (this.nextSession && !this.nextSession.currentUserJoined) {
        try {
          const response = await api.REQUEST({
            method: "post",
            url: `/api/sessions/upcoming/${this.nextSession.SID}/joined`,
            withCredentials: true,
          });
          console.log("SET USER AS JOINED: response", JSON.parse(JSON.stringify(response)));
        } catch (error) {
          console.error("failed @setUserAsJoined", error);
        }

        this.$store.dispatch("upcomingMatches/setUserAsJoined");
      }
    },

    /* ======== AUDIO ======== */
    // playEndAudio() {
    //   console.log("playing end audio...");
    //   this.activeAudio = this.audios[0];
    //   this.activeAudio.isPlaying = true;
    //   this.activeAudio.file.volume = 0.2;
    //   this.activeAudio.file.play();
    // },

    // pauseSound() {
    //   console.log("pausing sound!");
    //   this.activeAudio.isPlaying = false;
    //   this.activeAudio.file.pause();
    //   this.activeAudio.file.currentTime = 0;
    // },

    playStartAudio() {
      const audio = new Audio(require("../../assets/audio/startding.mp3"));
      audio.volume = 0.2;
      audio.play();
      this.startAudioPlayed = true;
    },
  },
  watch: {
    STATE: function(newState) {
      /* if state changed to a state before start, ensure that completion stuff is reset */
      if (newState < this.states.STARTED && !this.sessionHasStarted) {
        Object.assign(this.$data, initialDataState());
      }
      /* if state changed to started and the start date is approximately the current date, play audio */
      if (newState === this.states.STARTED && Math.abs(this.nextSessionDateTimeMS - Date.now()) < 1000) {
        this.setUserAsJoined();
        this.playStartAudio();
      }
      /* if state changed to end and the end date is approximately the current date, play end audio */
      if (newState === this.states.SESSION_END && Math.abs(this.nextSessionEndTimeMS - Date.now()) < 1500) {
        console.log("COMPLETING SESSION");
        this.completeSession();
      }
    },
  },
};

function initialDataState() {
  return {
    /* This setup allows for the user to later choose which
    sound they wish to play at the end of the session, and here
    will be reflected by a number choice in array[0] */
    audios: [
      {
        id: "swing",
        name: "Swing",
        file: new Audio(require("../../assets/audio/swing.mp3")),
        isPlaying: false,
      },
    ],
    activeAudio: null,
    startAudioPlayed: false,
    sessionConclusionDone: false,
  };
}
</script>

<style>
@import "./TimerStyles/SessionTimer.css";
</style>
